import type { Project, Vault } from '@prisma/client'
import { IntervalQuery } from 'modules/time-navigation/defs'

// Based on:
// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

// prettier-ignore
export const serverQueryKeys = {
  server:   ['server'] as const,
  whoami:   ['server', 'whoami'] as const,
  vaults:   ['server', 'vaults'] as const,
  vault:    (vaultID: Vault['id']) => [...serverQueryKeys.vaults, vaultID] as const,
  projects: ['server', 'projects'] as const,
  project:  (projectID: Project['id']) => [...serverQueryKeys.projects, projectID] as const
}

// prettier-ignore
export const clientQueryKeys = {
  projectUsage: (projectID: Project['id']) => ['client', 'projects', projectID, 'usage'] as const,
  projectAnalytics: (projectID: Project['id']) => ['client', 'projects', projectID, 'analytics'] as const,
  projectAnalyticsInterval: (projectID: Project['id'], interval: IntervalQuery) => ['client', 'projects', projectID, 'analytics', interval] as const,
}
